import React from "react";

import { Col } from "reactstrap";

export default class Describe extends React.Component {
  render() {
    return (
      <Col>
        <h5 style={{ color: "rgb(0,54,99", fontWeight:700}}>{this.props.heading}</h5>
        <p>{this.props.text}</p>
      </Col>
    );
  }
}
